import ApiService from "./api.service";
export default class AddressService extends ApiService {
    static base_url = `${super.base_url}/addresses`;
}
